/* eslint camelcase: 0 */
import { Industry } from '@/infrastructure/network/Monitaro/schema/models'
import { IIndustryProps, EmptyIndustryPropsFactory } from '@/entities/Industry'

export const toIndustryProps = (props: Industry | null | undefined): IIndustryProps => {
  if (!props) {
    return EmptyIndustryPropsFactory()
  }

  const { id, name, order, chargeable, properties, created_at, updated_at } = props

  return EmptyIndustryPropsFactory({
    id,
    name,
    order,
    chargeable,
    properties,
    createdAt: created_at,
    updatedAt: updated_at
  })
}
